import $ from 'jquery';
import screenfull from 'screenfull';

export default class FullScreen {
	constructor() {
		this.classes = { off: 'off' };
	}

	isEnabled() {
		return screenfull?.enabled ?? false;
	}

	isFullscreen() {
		return screenfull?.isFullscreen ?? false;
	}

	toggle(element = document.documentElement) {
		if (this.isEnabled()) {
			screenfull.toggle(element);
		}
	}

	_updateButton(button) {
		if (this.isFullscreen()) {
			button.addClass(this.classes.off);
		} else {
			button.removeClass(this.classes.off);
		}
	}

	_handleClick(button, element) {
		button.on('click.fullscreen', () => {
			this.toggle(element);
		});

		if (!this.isEnabled()) return;

		// Proper event listener
		screenfull.on('change', () => {
			this._updateButton(button);
		});

		this._updateButton(button);
	}

	setup(button, element) {
		if (!this.isEnabled()) return;

		const btn = button instanceof $ ? button : $(button);
		const el = element instanceof $ ? element[0] : element || document.documentElement;

		this._handleClick(btn, el);
	}
}
